// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1p-YS","row":"styles_row__2evL-"};